import { z } from 'zod';

export const COOKIE_CATEGORIES = ['zorunlu', 'islevsel', 'analitik', 'pazarlama'];
export const COOKIE_PARTIES = ['first_party', 'third_party'];

const objectId = z.string().regex(/^[a-f\d]{24}$/i, 'Invalid ObjectId');

export const CookieInventorySchema = z.object({
    name: z.string().min(1).max(200),
    provider: z.string().max(200).optional().or(z.literal('')),
    domain: z.string().max(200).optional().or(z.literal('')),
    category: z.enum(COOKIE_CATEGORIES).default('zorunlu'),
    party: z.enum(COOKIE_PARTIES).default('first_party'),
    purpose: z.string().max(2000).optional().or(z.literal('')),
    duration: z.string().max(100).optional().or(z.literal('')),
    consentRequired: z.boolean().optional(),
    linkedPrivacyNoticeId: objectId.nullable().optional(),
    linkedConsentId: objectId.nullable().optional(),
    status: z.enum(['active', 'inactive']).default('active'),
    customFields: z.record(z.any()).optional(),
});

export const CreateCookieInventorySchema = CookieInventorySchema.extend({
    linkedConsentId: objectId,
});
export const UpdateCookieInventorySchema = CookieInventorySchema.partial();
